import Typography from "@/components/foundation/typography"
import React from "react"
import style from "./style.scss"

interface MissionItemInstructionsProps {
  openModal: (index?: number) => void
  index?: number
}

const MissionItemInstructions: React.SFC<
  Readonly<MissionItemInstructionsProps>
> = (props) => {
  return (
    <div className={style.instructions}>
      <button type="button" onClick={() => props.openModal(props.index)}>
        <Typography.P2 as="span">Review instructions</Typography.P2>
      </button>
    </div>
  )
}

export default MissionItemInstructions
